import React, {PureComponent} from "react";
import GridItem from "./GridItem/GridItem";
import NoContent from "../NoContent/NoContent";
import Analytics from "../../libs/analytics";
import Dots from "../../ui/Dots/Dots";
import {Box, Container, Grid as GridMui} from "@mui/material";
import axios from "axios";
import ClientConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import ModalView from "../ModalView/ModalView";
import GridItemSkeleton from "./GridItemSkeleton";

class GridContent extends PureComponent {
    constructor(props) {
        super(props);
        const {termToSearch, currentAsset} = props;
        this.state = {
            content: null,
            assets: [],
            page: 0,
            currentAsset: currentAsset,
            searchTerm: termToSearch,
            loading: false,
            enableLoading: true,
            openModal: false,
            activePosition: 0
        }
    }

    componentDidMount() {
        console.log('component did mount');
        this.loadMoreAssets();
        window.addEventListener("scroll", ()=>{
             this.onScroll();
        });
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", ()=>{
            this.onScroll();
        });
    }

    onClickItem = ({item, index}) =>{
        this.setState({openModal: true, activePosition: index, content: item});
    }

    loadMoreAssets = () => {
        const {loading} = this.state;

        if (loading){
            return;
        }
        this.setState({loading: true});
        const {page} = this.state;
        const pageToLoad = page + 1;

        const {category, contentTitle, creator_id, search_tag, sort, setTotal, query, productsFilter} = this.props;


        let content = "";


        let contentFilters = ``;
        let contentSort = "";


        if (contentTitle && contentTitle?.trim() !== "") {
            contentFilters = `{search:{ term: "${contentTitle}", mode: strict }}`;
        }
        if (query && query?.trim() !== "") {
            contentFilters = `{search:{ term: "${query}", mode: flexible, source: extended}}`;
        }
        if (creator_id && creator_id?.trim() !== "") {
            contentFilters = `{creator_id: ${creator_id} }`;
        }
        if (search_tag && search_tag?.trim() !== "") {
            contentFilters = `{search_tag: "${search_tag}"}`;
        }
        if (category && category !== "All") {
            contentFilters = contentFilters + `,{attribute:{ code: "category", value:"${category}"}}`;
        }
        if (sort) {
            const value = sort;
            if (value === "most_recent") {
                contentSort = `, sort:{name: publish_date, direction: desc}`;
            }
            if (value === "creator_name") {
                contentSort = `, sort:{name: last_name, direction: asc}`;
            }
            if (value === "with_video") {
                contentSort = `, sort:{name: content_type, direction: desc}`;
            }
            if (value === "views") {
                contentSort = `, sort:{name: engagement, direction: desc}`;
            }
        }

        if (contentFilters) {
            content = `, filter: {
            AND:[
                ${contentFilters}
            ]
            }`
        }else if(productsFilter.length > 0){
            content = `, filter: {

                OR:[ ${productsFilter.map(m=>`{product: ${m}}`).join(",")} ]

            }`
        }


        this.s = `
                {
                  content(per_page: 12, page : ${pageToLoad}, ${content} ${contentSort}) {
                    total
                    items {
                      content_id
                      title
                      uri_stem
                      description
                      page_url
                      asset{
                        asset_type
                        youtube{
                            youtube_id
                            height
                            width
                            duration
                            thumbnail
                            youtube_url
                        }
                        photo{
                          sources{
                            height
                            width
                            url
                          }
                          thumbnails{
                            url
                            height
                            width
                          }
                        }
                        video{
                          thumbnails{
                            url
                            height
                            width
                          }
                          sources{
                            hls
                            dash
                            mp4{
                              height
                              width
                              url
                            }
                          }
                        }
                      }
                      creator{
                        creator_id
                        full_name
                        thumbnail
                      }
                      products{
                         product_id
                         title
                         image
                         link
                         price
                         sale_price
                         description
                      }
                    creator {
                        creator_id
                        employee_id
                        uri_stem
                        thumbnail
                        first_name
                        full_name
                        last_name
                        region {
                            name
                        }
                        store {
                            name
                            store_number
                        }
                    }
                      attributes{
                        code,
                        value
                      }
                      content_type,
                      creation_date
                    }
                  }
                }
                `;
        const requestQuery = this.s;


        axios.post(ClientConfigurationHelper.getContentSearchUrl(), {query: requestQuery}, {withCredentials: true}).then(response => {

            const items = response.data.data.content.items.map(item => {

                const attribute = item.attributes?.find?.(f => f.code === "category");
                const category = attribute?.value[0] || "";
                const assetType = {
                    'youtube': 'youtube',
                    'video': 'mp4',
                    'photo': 'photo'
                };
                const buildVideoSrc = video =>{
                    return {
                        src: video.url,
                        file: video.url,
                        mime: "video/mp4",
                        height: video.height,
                        width: video.width
                    }
                }
                const buildSources = asset =>{
                    const {asset_type} = asset;
                    if(asset_type === "youtube"){
                        return {videoId: asset.youtube.youtube_id, thumbnailUrl: asset.youtube.thumbnail}
                    }else if(asset_type === "video"){
                        return {hls: asset.video.hsl, dash: asset.video.dash, sources: asset.video.sources.mp4.map(buildVideoSrc), thumbnails: asset.video.thumbnails}
                    }else{
                        return {sources: asset.photo.sources, thumbnails: asset.photo.thumbnails}
                    }
                }
                const asset = {
                    type: assetType[item?.asset?.asset_type],
                    ...buildSources(item?.asset)
                }
                return {
                    title: item.title,
                    creator: item.creator,
                    uri_stem: item.uri_stem,
                    user_id: item?.creator?.creator_id,
                    description: item.description,
                    id: item.content_id,
                    content_id: item.content_id,
                    category: category,
                    entityType: item.content_type === "video" ? 1 : 7,
                    products: item?.products || [],
                    asset: asset
                };
            });
            const total = response.data.data.content.total || 0;
            if (typeof setTotal === "function" && pageToLoad === 1) {
                setTotal(total);
            }

            const currenItemsLoaded = page * 12;
            if(currenItemsLoaded > total){
                this.setState({enableLoading: false});
            }
            this.setAssetsFromResponse(items);
        }).catch(error => {
            console.log('error loading grid items');
        });
    }

    onScroll = () => {
        const {loading, enableLoading} = this.state;
        if (loading) return;
        const scrollTo = window.pageYOffset || document.documentElement.scrollTop;
        const newWindowHeight = document.documentElement.offsetHeight - window.innerHeight;
        const percentDocument = (scrollTo * 100) / newWindowHeight;
        if (percentDocument > 80 && enableLoading) {
            console.log('reset when scroll is valid', percentDocument, enableLoading);
            this.loadMoreAssets();
        }
    }

    setAssetsFromResponse = (data) => {
        const {assets, page, searchTerm} = this.state;
        //const {data: resData} = response, {result} = resData;


        let newState = {};
        if ((data && data.length)) {
            if (data.length > 0 && this.props.pmEvent && page === 0 && !searchTerm) {
                Analytics.pmEvent(data[0]);
            }
            newState = {
                assets: assets.concat(data),
                page: page + 1
            };
        } else {
            if (page === 0 && this.props.noResultsCallback)
                this.props.noResultsCallback();
        }
        newState.loading = false;
        this.setState(newState);
    }

    getGridItemFromAsset = (asset, key) => {
        const {lazyLoadingThumbnails, redirect} = this.props;
        const {currentAsset} = this.state;
        return <GridMui key={asset.id} item xs={12} sm={6} lg={4}>
            <GridItem
                key={asset.id}
                index={key}
                onClickItem={this.onClickItem}
                redirect={redirect}
                dataTestid="tvp-grid-item"
                asset={asset}
                playing={asset.id === currentAsset}
                maxDescriptionLines={2}
                lazyLoadingThumbnails={lazyLoadingThumbnails}/>
        </GridMui>;

    }
    onNext = () =>{
        const {assets, activePosition} = this.state;
        const newItem = activePosition + 1;
        if(assets[newItem]){
            this.setState({
                activePosition: newItem,
                content: assets[newItem]
            })
        }
    }
    onPrev = () =>{
        const {assets, activePosition} = this.state;
        const newIndex = activePosition - 1;
        const newItem = newIndex < 0 ? 0 : newIndex;
        if(assets[newItem]){
            this.setState({
                activePosition: newItem,
                content: assets[newItem]
            })
        }
    }
    onCloseModal = () =>{
        this.setState({openModal: false});
    }
    render() {
        const {assets, loading, enableLoading, searchTerm, activePosition, openModal, content} = this.state;
        const {category, sort, redirect} = this.props;
        const filteredBy = category ? "category" : "none";
        const sortedBy = sort ? sort : "none";
        return (
            <Box data-testid="tvp-grid" data-filteredBy={filteredBy} data-sortedBy={sortedBy}>
                <Container>
                    {(!enableLoading && searchTerm || (!assets || !assets.length && !loading)) && <NoContent>
                        <div className={"no-results"}>No results found.</div>
                    </NoContent>}
                    <GridMui container spacing={2}>
                        {
                            assets.map(this.getGridItemFromAsset)
                        }
                        {loading && [1, 2, 3, 4, 5, 6].map((item, index) => {
                            return <GridItemSkeleton key={index} />
                        })}
                    </GridMui>

                </Container>
                {redirect === false && <ModalView
                    getPrev={this.onPrev}
                    getNext={this.onNext}
                    activePosition={activePosition}
                    autoplay={true}
                    videos={assets}
                    modal={{open: openModal, content: content, position: activePosition}}
                    closeModal={this.onCloseModal} />}
            </Box>
        );
    }
}

GridContent.defaultProps = {
    gridTitle: "Watch the latest",
    redirect: true,
    pmEvent: true,
    noResultsCallback: () => {
    },
    productsFilter: [],
    showNoResults: false,
    lazyLoadingThumbnails: true
};

export default GridContent;
